import * as types from '../mutation-types';
import ticketsAPI from '../../api/tickets';

const state = {
  records: [],
  meta: {
    current_page: 1,
    total_pages: 1,
    total_count: 0,
  },
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

const getters = {
  getTickets: $state => $state.records,
  getMeta: $state => $state.meta,
  getUIFlags: $state => $state.uiFlags,
};

const actions = {
  get: async ({ commit }, { page = 1, since, until, q, filter } = {}) => {
    commit(types.SET_TICKETS_UI_FLAG, { isFetching: true });
    try {
      const response = await ticketsAPI.get({ page, since, until, q, filter });
      commit(types.SET_TICKETS, response.data.payload);
      commit('SET_TICKETS_META', response.data.meta);
    } finally {
      commit(types.SET_TICKETS_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, data) => {
    commit(types.SET_TICKETS_UI_FLAG, { isCreating: true });
    try {
      const response = await ticketsAPI.create(data);
      commit(types.ADD_TICKET, response.data);
      return response.data;
    } finally {
      commit(types.SET_TICKETS_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...data }) => {
    commit(types.SET_TICKETS_UI_FLAG, { isUpdating: true });
    try {
      const response = await ticketsAPI.update(id, data);
      commit(types.EDIT_TICKET, response.data);
      return response.data;
    } finally {
      commit(types.SET_TICKETS_UI_FLAG, { isUpdating: false });
    }
  },
};

const mutations = {
  [types.SET_TICKETS_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.SET_TICKETS]($state, data) {
    $state.records = data;
  },
  SET_TICKETS_META($state, data) {
    $state.meta = data;
  },
  [types.ADD_TICKET]($state, data) {
    $state.records.unshift(data);
  },
  [types.EDIT_TICKET]($state, data) {
    const index = $state.records.findIndex(ticket => ticket.id === data.id);
    if (index > -1) {
      $state.records.splice(index, 1, data);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
